<template lang="pug">
  v-select(
    :value="value"
    v-bind="$attrs"
    label="Тип"
    rounded
    filled
    item-value="id"
    item-text="name"
    :items="items"
    @input="$emit('input', $event)"
  )
</template>

<script>
import { COURSE_TYPE_NAMES } from '@/utils/constants';

export default {
  props: {
    value: { type: [String, Number], default: null },
    availableTypes: { type: Array, default: () => [] },
  },
  // data() {
  //   return {
  //     COURSE_TYPE_NAMES,
  //   };
  // },
  computed: {
    items() {
      if (this.availableTypes.length) {
        return COURSE_TYPE_NAMES
          .filter((i) => this.availableTypes.map((type) => +type).includes(i.id));
      }
      return COURSE_TYPE_NAMES;
    },
  },
};
</script>
